export default "__VITE_ASSET__re7SaCuV__"